export default __webpack_public_path__ + "static/media/ilustrativen-virtuoz.40620993.gif";